class PlayersListController {
  constructor(
    TeamsFactory,
    PaymentsFactory,
    PlayersFactory,
    TrainingEntriesFactory,
    TrainingCentersFactory,
    $filter,
    ngDialog,
    $state,
    $rootScope,
    URLS
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      vm.activeTeam = null;
      vm.teams = [];
      vm.filters = {};
      vm.filters.hasPaid = false;
      vm.trainingCenters = [];
      if (vm.rootScope.user.isUserTypeTeam()) {
        vm.activeTeam = vm.rootScope.currentUser;
        vm.reloadPlayers();
      } else {
        TeamsFactory.getAll().then((response) => {
          vm.teams = response.data;
        });
      }
      TrainingCentersFactory.getAll().then((response) => {
        vm.trainingCenters = response.data;
      });
    };

    vm.gridOptions = {
      enableSorting: true,
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "image",
          name: "",
          enableFiltering: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' +
            '<span class="avatar w-32">' +
            '<img class="{{grid.appScope.vm.getPlayerHighestLevelClass(row.entity)}}" ng-src="{{grid.appScope.vm.getPlayerImage(row.entity)}}">' +
            '<i class="on b-white bottom"></i>' +
            "</span>" +
            "</div>",
          width: "80",
        },
        {
          field: "code",
          enableFiltering: false,
          name: $translate("CODE"),
          width: "90",
        },
        {
          field: "playerName",
          name: $translate("NAME"),
          enableFiltering: true,
        },
        {
          field: "teamName",
          name: $translate("TEAM"),
          enableFiltering: true,
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<a href class="btn btn-sm btn-info m-l-1" translate ' +
            'ng-click="grid.appScope.vm.goToProfile(row.entity.player_id)">PROFILE</a>' +
            '<a href class="btn btn-sm btn-warning m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_PLAYER)" ' +
            'ng-click="grid.appScope.vm.goToEdit(row.entity.player_id)">EDIT</a>' +
            '<button class="btn btn-sm btn-danger m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_PLAYER)" ' +
            'ng-click="grid.appScope.vm.deletePlayer(row.entity.player_id)">DELETE</button>' +
            '<button class="btn btn-sm btn-dark m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' +
            'ng-click="grid.appScope.vm.getCard(row.entity.player_id)">DOWNLOAD_CARD</button>' +
            '<button class="btn btn-sm accent m-l-1" translate ' +
            'data-toggle="modal" ' +
            'data-target="#playerTrainingEntriesModal" ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.ADD_TRAINING_ENTRY)" ' +
            'ng-click="grid.appScope.vm.openAddTrainingEntriesModal(row.entity.player_id)">ADD_TRAINING_ENTRIES</button>' +
            "</div>" +
            "</div>",
          width: "520",
        },
      ],
    };

    vm.openAddTrainingEntriesModal = (playerId) => {
      vm.newEntries = {
        player_id: playerId,
      };
    };

    vm.addNewEntries = () => {
      TrainingEntriesFactory.create({
        amount: vm.newEntries.amount,
        training_center_id: vm.newEntries.trainingCenter.id,
        player_id: vm.newEntries.player_id,
      }).then((response) => {
        ngDialog.open({ template: "successTemplate" });
      });
    };

    vm.getCard = (player) => {
      const tabWindowId = window.open("about:blank", "_blank");
      PlayersFactory.card(player).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };

    vm.hasPermission = (permission) => {
      if (vm.rootScope.user.isUserTypeTeam()) {
        return (
          vm.rootScope.user.isTeam(vm.activeTeam.team_id) &&
          vm.rootScope.user.canDo(permission)
        );
      } else {
        return vm.rootScope.user.canDo(permission);
      }
    };

    vm.getPlayerHighestLevelClass = (player) => {
      if (player.compound_level > player.recurve_level) {
        return `level-indicator level-${player.compound_level}`;
      }
      return `level-indicator level-${player.recurve_level}`;
    };

    vm.getPlayerImage = (entity) => {
      if (entity.img) {
        return URLS.IMAGES_URL + "/players/" + entity.img;
      } else {
        return "assets/images/no_avatar.png";
      }
    };

    vm.deletePlayer = (playerId) => {
      ngDialog
        .openConfirm({
          template: "confirmTemplate",
          data: {
            message: $translate("CONFIRM_DELETE_PLAYER"),
          },
        })
        .then(() => {
          PlayersFactory.delete(playerId).then((response) => {
            ngDialog.open({ template: "successTemplate" });
            vm.reloadPlayers();
          });
        });
    };

    vm.goToProfile = (playerId) => {
      $state.go("player-profile.info", { id: playerId });
    };

    vm.goToEdit = (playerId) => {
      $state.go("player-edit", { id: playerId });
    };

    vm.reloadPlayers = () => {
      let params = {};
      /* Active Team Filter */
      if (vm.activeTeam) {
        params.team_id = vm.activeTeam.team_id;
      } else if (!vm.hasPermission(vm.rootScope.permissions.VIEW_ALL_PLAYERS)) {
        return;
      }
      /* Has Paid For Year Filter */
      if (vm.filters.hasPaid) {
        params.has_paid = 1;
      }
      /* Page Size */
      params.page_size = 9000;
      PlayersFactory.getAll(params).then((response) => {
        vm.players = response.data;
        vm.gridOptions.data = response.data;
      });
    };
  }
}

export default PlayersListController;



// WEBPACK FOOTER //
// ./client/app/components/players/playersList/playersList.controller.js